<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title1">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1">1. The L’oste Vineyard</a></p>
<p class="toc"><span href="#/Chapter2" title="Link target outside of Sample">2. Keokuk and Black Hawk</span></p>
<p class="toc"><span href="#/Chapter3" title="Link target outside of Sample">3. White Elk Winery</span></p>
<p class="toc"><span href="#/Chapter4" title="Link target outside of Sample">4. Council Bluffs Grape Growers Association</span></p>
<p class="toc"><span href="#/Chapter5" title="Link target outside of Sample">5. Amana Colonies: Ten Wineries</span></p>
<p class="toc"><span href="#/Chapter6" title="Link target outside of Sample">6. Challenges of Growing in Iowa</span></p>
<p class="toc"><span href="#/Chapter7" title="Link target outside of Sample">7. Vineyard Revival</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?3c9aa313